import React from 'react'
import { Admin, Resource, AuthProvider } from 'admin-on-rest'

import RestClient from './rest/restClient'
import AuthClient from './rest/authClient'
import customRoutes from './customRoutes'

import Login from './auth/loginPage'

import studentsReducer from './reducers/studentsReducer'
import coursesReducer from './reducers/coursesReducer'
import instructorsReducer from './reducers/instructorsReducer'

import studentProfileSaga from './sagas/studentsSaga'
import coursesSaga from './sagas/coursesSaga'
import instructorsSaga from './sagas/instructorsSaga'

import { AdminCoursesList } from './admin/AdminCoursesList'
import { AdminCourseCreate } from './admin/AdminCourseCreate'
import { AdminCourseEdit } from './admin/AdminCourseEdit'
import { AdminCourseRemove } from './admin/AdminCourseRemove'
import { AdminCourseShow } from './admin/AdminCourseShow'
import AdminCoursesCompletedList from './admin/AdminCoursesCompletedList'
import { AdminStudentsList } from './admin/AdminStudentsList'
import { AdminInstructorsList } from './admin/AdminInstructorsList'
import AdminInstructorCreate from './admin/AdminInstructorCreate'
import { AdminInstructorEdit } from './admin/AdminInstructorEdit'

import InstructorsCoursesInProgress from './instructors/InstructorsCoursesInProgress'
import InstructorsCoursesUpcoming from './instructors/InstructorsCoursesUpcoming'
import InstructorsCoursesCompleted from './instructors/InstructorsCoursesCompleted'

import StudentsCoursesInProgressList from './students/StudentsCoursesInProgressList'
import StudentsCoursesAvailableList from './students/StudentsCoursesAvailableList'
import StudentsCoursesEnrolledList from './students/StudentsCoursesEnrolledList'
import StudentCredits from './students/StudentCredits'

import messages from './messages'

import Menu from './customMenu'
import Dashboard from './dashboard'

const App = () => (
  <Admin
    menu={Menu}
    authClient={AuthClient}
    restClient={RestClient()}
    title={
      <span>
        <a href="/" style={{ textDecoration: 'none', color: 'white' }}>
          Management cursuri OAMMR Timis
        </a>
      </span>
    }
    loginPage={Login}
    customReducers={{
      students: studentsReducer,
      courses: coursesReducer,
      instructors: instructorsReducer,
    }}
    customSagas={[studentProfileSaga, coursesSaga, instructorsSaga]}
    dashboard={Dashboard}
    customRoutes={customRoutes}
    locale="ro"
    messages={messages}
  >
    {/*************
     Admin 
    *************/}
    <Resource
      name="courses"
      show={AdminCourseShow}
      list={AdminCoursesList}
      create={AdminCourseCreate}
      edit={AdminCourseEdit}
      remove={AdminCourseRemove}
    />
    <Resource name="courses-completed" list={AdminCoursesCompletedList} />
    <Resource name="students" list={AdminStudentsList} />
    <Resource
      name="instructors"
      list={AdminInstructorsList}
      create={AdminInstructorCreate}
      edit={AdminInstructorEdit}
    />
    {/*************
     Students 
    *************/}
    <Resource name="cursuri-disponibile" list={StudentsCoursesAvailableList} />
    <Resource name="cursuri-inscrise" list={StudentsCoursesEnrolledList} />
    <Resource
      name="cursuri-in-desfasurare"
      list={StudentsCoursesInProgressList}
    />
    <Resource name="credits" list={StudentCredits} />
    {/*************
     Instructors 
    *************/}
    <Resource
      name="instructors-in-progress"
      list={InstructorsCoursesInProgress}
    />
    <Resource name="instructors-upcoming" list={InstructorsCoursesUpcoming} />
    <Resource name="instructors-completed" list={InstructorsCoursesCompleted} />
  </Admin>
)

export default App

window.addEventListener('rejectionhandled', event => {
  console.log('Unhandled promise' + event)
})



// WEBPACK FOOTER //
// ./src/App.js